"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = Accordion;
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _colors = require("../../common/colors");
var _context = require("../../common/context");
var _hooks = require("../../common/hooks");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _FlexItem = require("../layout/FlexItem");
var _Frow = require("../layout/Frow");
var _typography = require("../typography/typography");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Accordion(_ref) {
  var children = _ref.children,
    _ref$defaultIsOpen = _ref.defaultIsOpen,
    defaultIsOpen = _ref$defaultIsOpen === void 0 ? false : _ref$defaultIsOpen,
    controlledIsOpen = _ref.isOpen,
    minimal = _ref.minimal,
    subtext = _ref.subtext,
    text = _ref.text,
    triggerClass = _ref.triggerClass;
  var isControlled = controlledIsOpen !== undefined;
  var _useVisibility = (0, _hooks.useVisibility)(controlledIsOpen !== null && controlledIsOpen !== void 0 ? controlledIsOpen : defaultIsOpen),
    isOpen = _useVisibility.isOpen,
    setIsOpen = _useVisibility.setIsOpen,
    toggleOpen = _useVisibility.toggleOpen;

  // Keep internal state in sync with controlled prop
  React.useEffect(function () {
    if (isControlled) {
      setIsOpen(controlledIsOpen);
    }
  }, [controlledIsOpen, isControlled, setIsOpen]);

  // When using uncontrolled, user actions change the state; when using controlled, parent changes state
  var handleToggle = function handleToggle() {
    if (!isControlled) {
      toggleOpen();
    }
  };
  var wrapperClassName = (0, _classnames.default)(_defineProperty({}, _classes.Classes.MINIMAL, minimal), _classes.Classes.ACCORDION);
  var triggerClassName = (0, _classnames.default)(_defineProperty({}, _classes.Classes.ACTIVE, isOpen), _classes.Classes.ACCORDION_TRIGGER, triggerClass);
  var headerIcon = isOpen ? _iconNames.IconNames16.CHEVRON_UP : _iconNames.IconNames16.CHEVRON_DOWN;
  var leftElement = typeof text === 'string' ? /*#__PURE__*/React.createElement(_typography.Body, null, text) : text;
  var visibilityValue = React.useMemo(function () {
    return {
      isOpen: isOpen
    };
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(_context.VisibilityContext.Provider, {
    value: visibilityValue
  }, /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleToggle,
    className: triggerClassName
  }, /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center",
    justifyContent: "space-between",
    gutters: 16,
    flexWrap: "nowrap"
  }, /*#__PURE__*/React.createElement(_FlexItem.FlexItem, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center",
    justifyContent: "space-between",
    gutters: 16,
    flexWrap: "nowrap"
  }, /*#__PURE__*/React.createElement(_FlexItem.FlexItem, null, leftElement), /*#__PURE__*/React.createElement(_FlexItem.FlexItem, null, /*#__PURE__*/React.createElement(_typography.Caption, {
    muted: true
  }, subtext)))), /*#__PURE__*/React.createElement(_FlexItem.FlexItem, null, /*#__PURE__*/React.createElement(_Frow.Frow, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(_Icon.Icon16, {
    icon: headerIcon,
    fill: _colors.Colors.GREY_50
  }))))), /*#__PURE__*/React.createElement(_core.Collapse, {
    isOpen: isOpen
  }, children)));
}